var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1399_844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 16.4386V1.99994C14.6667 1.63194 14.368 1.33325 14 1.33325C6.28 1.33325 0 8.21194 0 16.6666C0 25.1212 6.87869 31.9999 15.3333 31.9999C19.116 31.9999 21.1626 31.3146 23.7573 29.1813C24.036 28.9519 24.0813 28.5426 23.86 28.2573L14.6667 16.4386ZM15.3333 30.6666C7.61331 30.6666 1.33331 24.3866 1.33331 16.6666C1.33331 9.19463 6.65731 3.07063 13.3333 2.68531V16.6666C13.3333 16.8146 13.3826 16.9586 13.4746 17.0759L22.4026 28.5546C20.2973 30.1626 18.5413 30.6666 15.3333 30.6666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 16H31.3334C31.7014 16 32.0001 15.7013 32.0001 15.3333C32 6.87869 25.1213 0 16.6667 0C16.2987 0 16 0.298687 16 0.666687V15.3334C16 15.7013 16.2987 16 16.6667 16ZM17.3333 1.34931C24.524 1.688 30.312 7.476 30.6506 14.6666H17.3333V1.34931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3334 17.3333H18.0001C17.7441 17.3333 17.5081 17.4813 17.3974 17.7133C17.2867 17.9453 17.3201 18.2199 17.4814 18.4186L26.1481 29.1479C26.2641 29.2932 26.4347 29.3812 26.6201 29.3946C26.6361 29.3959 26.6507 29.3959 26.6667 29.3959C26.8347 29.3959 26.9974 29.3319 27.1214 29.2172C30.2214 26.3253 32.0001 22.2373 32.0001 17.9999C32.0001 17.6319 31.7014 17.3333 31.3334 17.3333ZM26.7241 27.7386L19.3961 18.6666H30.6507C30.4867 22.0559 29.0841 25.2973 26.7241 27.7386Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1399_844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4);
export default __webpack_public_path__ + "static/media/p4.d105266315fb778d4fee7b8844dacb23.svg";
export { ForwardRef as ReactComponent };